<div class="flex flex-col gap-2">

  <div class="flex flex-col md:flex-row gap-2 items-center portal-actions" *ngIf="needApplication">
    <span class="font-semibold text-lg">Add Administrator Information</span>
    <button mat-button type="button" color="primary" (click)="createApplication()">Add</button>
  </div>

  <div class="flex flex-row gap-2 portal-section-grid">
    <form [formGroup]="applicationForm" *ngIf="!needApplication" [ngClass]="viewingDuplicates? 'md:w-1/2' : 'w-full'">
      <div class="flex flex-col gap-2">
        <div class="flex flex-col" [ngClass]="!isChange && !viewingDuplicates? 'md:flex-row gap-2' : ''">
          <mat-card [ngClass]="!isChange && !viewingDuplicates? 'md:w-1/2' : ''" class="portal-full-panel portal-full-panel">
            <mat-card-content>
              <div class="flex flex-row gap-2 items-center portal-actions">
                <span class="font-semibold text-xl">Administrator Information</span>
                <div class="flex flex-row gap-4 ml-auto portal-actions">
                  <button type="button" *ngIf="application.possibleDuplicate"
                          mat-button color="primary" (click)="markNotADuplicate()">Mark Not a Duplicate</button>
                  <button type="button" *ngIf="application.possibleDuplicate && !viewingDuplicates"
                          mat-button color="warn" (click)="getDuplicateAdmins()">View Possible Duplicate</button>
                </div>
                <button class="ml-auto" type="button" *ngIf="approved && !isChange && isEditable"
                  mat-button color="primary" (click)="requestChange()">Change Administrator</button>
              </div>

              <div class="flex flex-col gap-2 pt-4">
                <!-- Review View-->
                <div *ngIf="!isEditable" class="flex flex-col gap-4">
                  <div class="flex flex-col md:flex-row gap-4 portal-field-grid admin-two-column">
                    <div class="flex flex-col gap-2 md:w-1/3">
                      <span class="font-semibold">First Name</span>
                      <span>{{application.firstName}}</span>
                    </div>

                    <div class="flex flex-col gap-2 md:w-1/3">
                      <span class="font-semibold">Last Name</span>
                      <span>{{application.lastName}}</span>
                    </div>

                    <div class="flex flex-col gap-2 md:w-1/3">
                      <span class="font-semibold">Middle Initial</span>
                      <span>{{application.middleInitial}}</span>
                    </div>
                  </div>

                  <div class="flex flex-col md:flex-row gap-4 portal-field-grid admin-two-column">
                    <div class="flex flex-col gap-2 md:w-1/3">
                      <span class="font-semibold">Phone</span>
                      <span>{{application.phone | mask:"000-000-0000"}}</span>
                    </div>

                    <div class="flex flex-col gap-2 md:w-1/3">
                      <span class="font-semibold">Email</span>
                      <span class="break-after-20">{{application.email}}</span>
                    </div>

                    <div class="flex flex-col gap-2 md:w-1/3">
                      <span class="font-semibold">Contact with Clients</span>
                      <span>{{application.contactWithClient? 'Yes' : 'No'}}</span>
                    </div>
                  </div>
                </div>

                <!-- Edit View-->
                <div *ngIf="isEditable" class="flex flex-col">
                  <div class="flex flex-col md:flex-row gap-2 portal-field-grid admin-two-column">

                    <div class="flex flex-col gap-2 md:w-2/5">
                      <span class="font-semibold">First Name</span>
                      <mat-form-field>
                        <mat-label>First</mat-label>
                        <input matInput formControlName="firstName">
                        <mat-error *ngIf="applicationForm.get('firstName').invalid">
                          First name is required
                        </mat-error>
                      </mat-form-field>
                    </div>

                    <div class="flex flex-col gap-2 md:w-2/5">
                      <span class="font-semibold">Last Name</span>
                      <mat-form-field>
                        <mat-label>Last</mat-label>
                        <input matInput formControlName="lastName">
                        <mat-error *ngIf="applicationForm.get('lastName').invalid">
                          Last name is required
                        </mat-error>
                      </mat-form-field>
                    </div>

                    <div class="flex flex-col gap-2 md:w-1/5">
                      <span class="font-semibold"><strong>Middle Initial</strong></span>
                      <mat-form-field>
                        <mat-label>M.I.</mat-label>
                        <input matInput formControlName="middleInitial">
                      </mat-form-field>
                    </div>
                  </div>

                  <div class="flex flex-col md:flex-row gap-2 portal-section-grid admin-two-column">
                    <div class="flex flex-col gap-2 md:w-1/3">
                      <span class="font-semibold"><strong>Phone</strong></span>
                      <mat-form-field>
                        <mat-label>Phone</mat-label>
                        <input matInput formControlName="phone" mask="000-000-0000">
                        <mat-error *ngIf="applicationForm.get('phone').hasError('required')">
                          Number is required
                        </mat-error>
                        <mat-error *ngIf="applicationForm.get('phone').hasError('pattern')">
                          Format as 000-000-0000
                        </mat-error>
                      </mat-form-field>
                    </div>

                    <div class="flex flex-col gap-2 md:w-1/3">
                      <span class="font-semibold">Email</span>
                      <mat-form-field>
                        <mat-label>Email</mat-label>
                        <input matInput formControlName="email">
                        <mat-error *ngIf="applicationForm.get('email').hasError('required')">
                        An email is required
                        </mat-error>
                        <mat-error *ngIf="applicationForm.get('email').hasError('email')">
                        This does not look like a valid email
                        </mat-error>
                      </mat-form-field>
                    </div>

                    <div class="flex flex-col gap-2 md:w-1/2">
                      <label id="admin-client-contact">
                        Administrator has direct contact with clients as defined in OAR 333-536-0093
                      </label>
                      <mat-radio-group aria-labelledby="admin-client-contact" formControlName="contactWithClient">
                        <mat-radio-button [value]="true">
                          Yes
                        </mat-radio-button>
                        <mat-radio-button [value]="false">
                          No
                        </mat-radio-button>
                      </mat-radio-group>
                    </div>
                  </div>
                </div>

                <span *ngIf="applicationForm.get('contactWithClient').value === false" class="text-red-500" [@slideRight]>
                  Note: The administrator reports that there will be no contact with clients.
                  Ensure that the administrator has included a plan for no contact.
                </span>

                <address class="pt-4"
                         [entityId]="application.id"
                         [entityType]="sharedService.administratorApplication"
                         [statuses]="statuses"
                         [limitEntries]="true"
                         [isChange]="isChange"
                         [isEditable]="isEditable"
                         (reportOutOfState)="updateOutOfState($event)"></address>

                <div class="flex flex-col gap-4" *ngIf="isOutOfState" [@slideRight]>
                  <span class="text-amber-800 font-semibold text-xl">This Administrator Resides Outside of Oregon</span>
                </div>

              </div>
            </mat-card-content>
          </mat-card>

          <mat-card [ngClass]="!isChange && !viewingDuplicates? 'md:w-1/2' : ''" class="portal-full-panel portal-full-panel">
            <mat-card-header>
              <mat-card-title class="pb-4">
                <span class="font-semibold text-xl">Education</span>
              </mat-card-title>
            </mat-card-header>
            <mat-card-content>

              <!-- Review View-->
              <div class="flex flex-col" *ngIf="!isEditable">
                <div class="flex flex-col gap-2 education-entry" *ngIf="application.highSchool">
                  <span class="font-semibold text-xl">High School / Equivalent</span>
                  <div class="flex flex-col md:flex-row w-full md:gap-2 portal-field-grid admin-two-column">
                    <div class="flex flex-col w-1/5">
                      <span class="font-semibold">School</span>
                      <span>{{application.highSchool}}</span>
                    </div>
                    <div class="flex flex-col w-1/5">
                      <span class="font-semibold">Address</span>
                      <span>{{application.highSchoolAddress}}</span>
                    </div>
                    <div class="flex flex-col w-1/5">
                      <span class="font-semibold">Dates</span>
                      <span>{{application.highSchoolFrom | date: 'MM/dd/yyyy'}}</span>
                      <span>{{application.highSchoolTo | date: 'MM/dd/yyyy'}}</span>
                    </div>
                    <div class="flex flex-col w-1/5">
                      <span class="font-semibold">Graduated</span>
                      <span>{{application.graduatedHighSchool? 'Yes' : 'No'}}</span>
                    </div>
                    <div class="flex flex-col w-1/5">
                      <span class="font-semibold">Degree</span>
                      <span>{{application.highSchoolDegree}}</span>
                    </div>
                  </div>
                </div>

                <div class="flex flex-col gap-2 education-entry" *ngIf="application.college">
                  <span class="font-semibold text-xl">College</span>
                  <div class="flex flex-col md:flex-row w-full md:gap-2 portal-field-grid admin-two-column">
                    <div class="flex flex-col w-1/5">
                      <span class="font-semibold">School</span>
                      <span>{{application.college}}</span>
                    </div>
                    <div class="flex flex-col w-1/5">
                      <span class="font-semibold">Address</span>
                      <span>{{application.collegeAddress}}</span>
                    </div>
                    <div class="flex flex-col w-1/5">
                      <span class="font-semibold">Dates</span>
                      <span>{{application.collegeFrom | date: 'MM/dd/yyyy'}}</span>
                      <span>{{application.collegeTo | date: 'MM/dd/yyyy'}}</span>
                    </div>
                    <div class="flex flex-col w-1/5">
                      <span class="font-semibold">Graduated</span>
                      <span>{{application.graduatedCollege? 'Yes' : 'No'}}</span>
                    </div>
                    <div class="flex flex-col w-1/5">
                      <span class="font-semibold">Degree</span>
                      <span>{{application.collegeDegree}}</span>
                    </div>
                  </div>
                </div>

                <div class="flex flex-col gap-2 education-entry" *ngIf="application.other">
                  <span class="font-semibold">Other</span>
                  <div class="flex flex-col md:flex-row w-full md:gap-2 portal-field-grid admin-two-column">
                    <div class="flex flex-col w-1/5">
                      <span class="font-semibold">School</span>
                      <span>{{application.other}}</span>
                    </div>
                    <div class="flex flex-col w-1/5">
                      <span class="font-semibold">Address</span>
                      <span>{{application.otherAddress}}</span>
                    </div>
                    <div class="flex flex-col w-1/5">
                      <span class="font-semibold">Dates</span>
                      <span>{{application.otherFrom | date: 'MM/dd/yyyy'}}</span>
                      <span>{{application.otherTo | date: 'MM/dd/yyyy'}}</span>
                    </div>
                    <div class="flex flex-col w-1/5">
                      <span class="font-semibold">Graduated</span>
                      <span>{{application.graduatedOther? 'Yes' : 'No'}}</span>
                    </div>
                    <div class="flex flex-col w-1/5">
                      <span class="font-semibold">Degree</span>
                      <span>{{application.otherDegree}}</span>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Edit View-->
              <div class="flex flex-col" *ngIf="isEditable">
                <div class="flex flex-col md:flex-row gap-2 portal-field-grid admin-two-column">
                  <div class="flex flex-col gap-2 md:w-2/5">
                    <span class="font-semibold">High School / Equivalent</span>
                    <mat-form-field>
                      <mat-label>Name</mat-label>
                      <input matInput formControlName="highSchool">
                    </mat-form-field>
                  </div>

                  <div class="flex flex-col gap-2 md:w-3/5" *ngIf="applicationForm.get('highSchool').value.length > 0" [@slideRight]>
                    <span class="font-semibold">Address</span>
                    <mat-form-field>
                      <mat-label>Address</mat-label>
                      <input matInput formControlName="highSchoolAddress">
                    </mat-form-field>
                  </div>
                </div>

                <div class="flex flex-col md:flex-row gap-2 md:items-center portal-section-grid admin-two-column" *ngIf="applicationForm.get('highSchool').value.length > 0" [@slideRight]>
                  <div class="flex flex-col md:w-1/4 gap-2 pt-5">
                    <span class="font-semibold">From</span>
                    <mat-form-field>
                      <input placeholder="mm/dd/yyyy" formControlName="highSchoolFrom" matInput [matDatepicker]="hsFrom" [max]="sharedService.today"/>
                      <mat-datepicker-toggle matSuffix [for]="hsFrom"></mat-datepicker-toggle>
                      <mat-datepicker #hsFrom>
                        <mat-datepicker-actions>
                          <button mat-raised-button color="primary" matDatepickerApply>Apply</button>
                          <button mat-button matDatepickerCancel>Cancel</button>
                        </mat-datepicker-actions>
                      </mat-datepicker>
                    </mat-form-field>
                  </div>

                  <div class="flex flex-col md:w-1/4 gap-2 pt-5">
                    <span class="font-semibold">To</span>
                    <mat-form-field>
                      <input placeholder="mm/dd/yyyy" formControlName="highSchoolTo" matInput [matDatepicker]="hsTo"
                      [min]="applicationForm.get('highSchoolFrom').value" [max]="sharedService.today" (blur)="validateHighSchoolTo()"/>
                      <mat-datepicker-toggle matSuffix [for]="hsTo"></mat-datepicker-toggle>
                      <mat-datepicker #hsTo>
                        <mat-datepicker-actions>
                          <button mat-raised-button color="primary" matDatepickerApply>Apply</button>
                          <button mat-button matDatepickerCancel>Cancel</button>
                        </mat-datepicker-actions>
                      </mat-datepicker>
                      <mat-error *ngIf="applicationForm.get('highSchoolTo').invalid">
                        To date cannot be before From date
                      </mat-error>
                    </mat-form-field>
                  </div>

                  <div class="flex flex-col gap-2 md:w-1/2">
                    <mat-checkbox formControlName="graduatedHighSchool" labelPosition="before">
                      <span class="font-semibold">Graduated</span>
                    </mat-checkbox>
                    <mat-form-field>
                      <mat-label>Degree</mat-label>
                      <input matInput formControlName="highSchoolDegree">
                    </mat-form-field>
                  </div>
                </div>

                <div class="flex flex-col md:flex-row gap-2 portal-field-grid admin-two-column education-divider">
                  <div class="flex flex-col gap-2 md:w-2/5">
                    <span class="font-semibold">College</span>
                    <mat-form-field>
                      <mat-label>Name</mat-label>
                      <input matInput formControlName="college">
                    </mat-form-field>
                  </div>

                  <div class="flex flex-col gap-2 md:w-3/5" *ngIf="applicationForm.get('college').value.length > 0" [@slideRight]>
                    <span class="font-semibold">Address</span>
                    <mat-form-field>
                      <mat-label>Address</mat-label>
                      <input matInput formControlName="collegeAddress">
                    </mat-form-field>
                  </div>
                </div>

                <div class="flex flex-col md:flex-row gap-2 md:items-center portal-section-grid admin-two-column" *ngIf="applicationForm.get('college').value.length > 0" [@slideRight]>
                  <div class="flex flex-col md:w-1/4 gap-2 pt-5">
                    <span class="font-semibold">From</span>
                    <mat-form-field>
                      <input placeholder="mm/dd/yyyy" formControlName="collegeFrom" matInput [matDatepicker]="colFrom" [max]="sharedService.today"/>
                      <mat-datepicker-toggle matSuffix [for]="colFrom"></mat-datepicker-toggle>
                      <mat-datepicker #colFrom>
                        <mat-datepicker-actions>
                          <button mat-raised-button color="primary" matDatepickerApply>Apply</button>
                          <button mat-button matDatepickerCancel>Cancel</button>
                        </mat-datepicker-actions>
                      </mat-datepicker>
                    </mat-form-field>
                  </div>

                  <div class="flex flex-col md:w-1/4 gap-2 pt-5">
                    <span class="font-semibold">To</span>
                    <mat-form-field>
                      <input placeholder="mm/dd/yyyy" formControlName="collegeTo" matInput [matDatepicker]="colTo"
                      [min]="applicationForm.get('collegeFrom').value" [max]="sharedService.today" (blur)="validateCollegeTo()"/>
                      <mat-datepicker-toggle matSuffix [for]="colTo"></mat-datepicker-toggle>
                      <mat-datepicker #colTo>
                        <mat-datepicker-actions>
                          <button mat-raised-button color="primary" matDatepickerApply>Apply</button>
                          <button mat-button matDatepickerCancel>Cancel</button>
                        </mat-datepicker-actions>
                      </mat-datepicker>
                      <mat-error *ngIf="applicationForm.get('collegeTo').invalid">
                        To date cannot be before From date
                      </mat-error>
                    </mat-form-field>
                  </div>

                  <div class="flex flex-col gap-2 md:w-1/2">
                    <mat-checkbox formControlName="graduatedCollege" labelPosition="before">
                      <span class="font-semibold">Graduated</span>
                    </mat-checkbox>
                    <mat-form-field>
                      <mat-label>Degree</mat-label>
                      <input matInput formControlName="collegeDegree">
                    </mat-form-field>
                  </div>
                </div>

                <div class="flex flex-col md:flex-row gap-2 portal-field-grid admin-two-column education-divider">
                  <div class="flex flex-col gap-2 md:w-2/5">
                    <span class="font-semibold">Other</span>
                    <mat-form-field>
                      <mat-label>Name</mat-label>
                      <input matInput formControlName="other">
                    </mat-form-field>
                  </div>

                  <div class="flex flex-col gap-2 md:w-3/5" *ngIf="applicationForm.get('other').value.length > 0" [@slideRight]>
                    <span class="font-semibold">Address</span>
                    <mat-form-field>
                      <mat-label>Address</mat-label>
                      <input matInput formControlName="otherAddress">
                    </mat-form-field>
                  </div>
                </div>

                <div class="flex flex-col md:flex-row gap-2 md:items-center portal-section-grid admin-two-column" *ngIf="applicationForm.get('other').value.length > 0" [@slideRight]>
                  <div class="flex flex-col md:w-1/4 gap-2 pt-5">
                    <span class="font-semibold">From</span>
                    <mat-form-field>
                      <input placeholder="mm/dd/yyyy" formControlName="otherFrom" matInput [matDatepicker]="otherFrom" [max]="sharedService.today"/>
                      <mat-datepicker-toggle matSuffix [for]="otherFrom"></mat-datepicker-toggle>
                      <mat-datepicker #otherFrom>
                        <mat-datepicker-actions>
                          <button mat-raised-button color="primary" matDatepickerApply>Apply</button>
                          <button mat-button matDatepickerCancel>Cancel</button>
                        </mat-datepicker-actions>
                      </mat-datepicker>
                    </mat-form-field>
                  </div>

                  <div class="flex flex-col md:w-1/4 gap-2 pt-5">
                    <span class="font-semibold">To</span>
                    <mat-form-field>
                      <input placeholder="mm/dd/yyyy" formControlName="otherTo" matInput [matDatepicker]="otherTo"
                      [min]="applicationForm.get('otherFrom').value" [max]="sharedService.today" (blur)="validateOtherTo()"/>
                      <mat-datepicker-toggle matSuffix [for]="otherTo"></mat-datepicker-toggle>
                      <mat-datepicker #otherTo>
                        <mat-datepicker-actions>
                          <button mat-raised-button color="primary" matDatepickerApply>Apply</button>
                          <button mat-button matDatepickerCancel>Cancel</button>
                        </mat-datepicker-actions>
                      </mat-datepicker>
                      <mat-error *ngIf="applicationForm.get('otherTo').invalid">
                        To date cannot be before From date
                      </mat-error>
                    </mat-form-field>
                  </div>

                  <div class="flex flex-col gap-2 md:w-1/2">
                    <mat-checkbox formControlName="graduatedOther" labelPosition="before">
                      <span class="font-semibold">Graduated</span>
                    </mat-checkbox>
                    <mat-form-field>
                      <mat-label>Degree</mat-label>
                      <input matInput formControlName="otherDegree">
                    </mat-form-field>
                  </div>
                </div>
              </div>
            </mat-card-content>
          </mat-card>
        </div>

        <div class="flex flex-col" [ngClass]="!isChange && !viewingDuplicates? 'md:flex-row gap-2' : ''">
          <mat-card [ngClass]="!isChange && !viewingDuplicates? 'md:w-1/2' : ''" class="portal-full-panel portal-full-panel">
            <mat-card-header>
              <mat-card-title>
                <span class="font-semibold text-xl">Management Experience</span>
              </mat-card-title>
            </mat-card-header>
            <mat-card-content>
              <div class="flex flex-col gap-2">
                <label id="has-management-experience">
                  Administrator has two or more years of management experience in a health related field
                </label>
                <mat-radio-group aria-labelledby="has-management-experience" formControlName="hasManagementExperience">
                  <mat-radio-button [value]="true">
                    Yes
                  </mat-radio-button>
                  <mat-radio-button [value]="false">
                    No
                  </mat-radio-button>
                  <div *ngIf="applicationForm.get('hasManagementExperience').invalid && applicationForm.get('hasManagementExperience').touched">
                    <mat-error>
                      Please select Yes or No
                    </mat-error>
                  </div>
                </mat-radio-group>

                <management-experience *ngIf="applicationForm.get('hasManagementExperience').value"
                                       [applicationId]="application.id"
                                       [isChange]="isChange"
                                       [isEditable]="isEditable"
                                       [statuses]="statuses"></management-experience>
              </div>
            </mat-card-content>
          </mat-card>

          <mat-card [ngClass]="!isChange && !viewingDuplicates? 'md:w-1/2' : ''" class="portal-full-panel portal-full-panel">
            <mat-card-header>
              <mat-card-title>
                <span class="font-semibold text-xl">Professional Experience</span>
              </mat-card-title>
            </mat-card-header>
            <mat-card-content>
              <div class="flex flex-col gap-2">
                <label id="has-professional-experience">
                  Administrator has two or more years of Professional experience in a health related field
                </label>
                <mat-radio-group aria-labelledby="has-professional-experience" formControlName="hasProfessionalExperience">
                  <mat-radio-button [value]="true">
                    Yes
                  </mat-radio-button>
                  <mat-radio-button [value]="false">
                    No
                  </mat-radio-button>
                  <div *ngIf="applicationForm.get('hasProfessionalExperience').invalid && applicationForm.get('hasProfessionalExperience').touched">
                    <mat-error>
                      Please select Yes or No
                    </mat-error>
                  </div>
                </mat-radio-group>

                <professional-experience *ngIf="applicationForm.get('hasProfessionalExperience').value"
                                         [applicationId]="application.id"
                                         [isEditable]="isEditable"
                                         [isChange]="isChange"
                                         [statuses]="statuses"></professional-experience>
              </div>
            </mat-card-content>
          </mat-card>
        </div>

        <mat-card [ngClass]="!isChange && !viewingDuplicates? 'md:w-2/3' : ''"
                  class="portal-full-panel portal-full-panel">
          <mat-card-content>
            <document [ngClass]="!isChange? 'md:w-1/2' : ''"
                      [entityId]="application.id"
                      [entityType]="sharedService.administratorApplication"
                      [statuses]="statuses"
                      [types]="administratorApplicationTypes"></document>
          </mat-card-content>
        </mat-card>
      </div>
    </form>

    <div *ngIf="viewingDuplicates" class="flex flex-col md:w-1/2" [@slideRight]>
      <div class="flex flex-col md:flex-row gap-4 portal-actions">
        <span class="text-lg font-semibold">Potential Duplicates</span>
        <button class="ml-auto" mat-button type="button" color="primary" (click)="closeDuplicates()">Close</button>
      </div>

      <mat-card *ngFor="let duplicate of duplicateAdmins">
        <mat-card-content>
          <div class="flex flex-col gap-2">
            <div class="flex flex-col md:flex-row gap-4 portal-field-grid">
              <div class="flex flex-col gap-2 md:w-1/3">
                <span class="font-semibold">First Name</span>
                <span>{{duplicate.firstName}}</span>
              </div>

              <div class="flex flex-col gap-2 md:w-1/3">
                <span class="font-semibold">Last Name</span>
                <span>{{duplicate.lastName}}</span>
              </div>

              <div class="flex flex-col gap-2 md:w-1/3">
                <span class="font-semibold">Middle Initial</span>
                <span>{{duplicate.middleInitial}}</span>
              </div>
            </div>

            <div class="flex flex-col md:flex-row gap-4 portal-field-grid">
              <div class="flex flex-col gap-2 md:w-1/3">
                <span class="font-semibold">Phone</span>
                <span>{{duplicate.phone | mask:"000-000-0000"}}</span>
              </div>

              <div class="flex flex-col gap-2 md:w-1/3">
                <span class="font-semibold">Email</span>
                <span class="break-after-20">{{duplicate.email}}</span>
              </div>

              <div class="flex flex-col gap-2 md:w-1/3">
                <span class="font-semibold">Contact with Clients</span>
                <span>{{duplicate.contactWithClient? 'Yes' : 'No'}}</span>
              </div>
            </div>

            <address class="pt-4"
                     [entityId]="duplicate.id"
                     [entityType]="sharedService.administratorApplication"
                     [statuses]="statuses"
                     [limitEntries]="true"
                     [isChange]="false"
                     [isEditable]="false"
                     (reportOutOfState)="updateOutOfState($event)"></address>
          </div>
        </mat-card-content>
      </mat-card>

    </div>
  </div>
</div>
